"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiteralValidator = void 0;
class LiteralValidator {
    // TODO Seems a bit strict by JD. Please check why tests are not failing.
    static hasValue(_element, _value) {
        return false;
    }
}
exports.LiteralValidator = LiteralValidator;
//# sourceMappingURL=literalValidator.js.map